export const COMPANY_NAME = 'VectorMethods';
export const PRODUCT_NAME = 'VideoVector';
export const COMPANY_CONTACT_URL = 'https://vectormethods.com/contact';
export const BRAND_LOGO_DARK_SRC = '/brand/vector-methods-logo-white-transparent.png';
export const BRAND_LOGO_LIGHT_SRC = '/brand/vector-methods-logo-black-transparent.png';
export const BRAND_MARK_DARK_SRC = '/brand/vector-methods-mark-white-transparent.png';
export const BRAND_MARK_LIGHT_SRC = '/brand/vector-methods-mark-black-transparent.png';
export const BRAND_FAVICON_DARK_SRC = '/favicon.png';
export const BRAND_FAVICON_LIGHT_SRC = '/favicon-light.png';
export const BRAND_LOGO_SRC = BRAND_LOGO_DARK_SRC;
export const BRAND_MARK_SRC = BRAND_MARK_DARK_SRC;
export const BRAND_LOGO_ALT = `${COMPANY_NAME} logo`;
